/* eslint-disable no-unused-vars */
import React from "react";
import { Card } from "antd";
import "./index.scss";

const Exceptions = () => {
  return (
    <Card className="exceptions-card">
      <div className="exceptions-header">
        <h3 className="card-title">Exceptions</h3>
      </div>
      <div className="exceptions-content coming-soon">
        <div className="coming-soon-message">
          <span className="coming-soon-text">Coming Soon</span>
        </div>
      </div>
    </Card>
  );
};

export default Exceptions;

